<template>
  <v-card>
    <v-card-title> People </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="6">
          <h4>Marital status:</h4>
          <p>{{ maritalStatus }}</p>
          <div v-if="testator.isMarried">
            <h5>Spouse/Partner:</h5>
            <p>{{ relations.spouse.fullName }}</p>
            <p v-if="isZAWill">{{ maritalRegime }}</p>
          </div>
        </v-col>
        <v-col cols="12" md="6">
          <div v-if="testator.hasChildren">
            <h4>Children:</h4>
            <ul>
              <li v-for="child in relations.children" :key="'Child' + child.id">
                {{ child.fullName }} - {{ age(child.dateOfBirth) }} years old
              </li>
            </ul>

            <h4 class="mt-4">Child guardians:</h4>
            <div v-if="relations.guardians.length">
              <ul>
                <li
                  v-for="guardian in relations.guardians"
                  :key="'Guardian' + guardian.id"
                >
                  {{ guardian.fullName }} -
                  {{ formatPersonKinship(guardian.kinship) }}
                </li>
              </ul>
            </div>
            <p v-else>No guardians appointed</p>

            <div v-if="isZAWill">
              <h4 class="mt-4">Trust:</h4>
              <div v-if="testator.createChildrensTrust">
                <p>
                  Trust termination age - {{ testator.trustTerminationAge }}
                </p>
                <h4>Trustees:</h4>
                <ul>
                  <li v-if="testator.companyIsTrustee">
                    {{ testator.company?.trustCompanyName }}
                  </li>
                  <li
                    v-for="trustee in relations.trustees"
                    :key="'Trustee' + trustee.id"
                  >
                    {{ trustee.fullName }} -
                    {{ formatPersonKinship(trustee.kinship) }}
                  </li>
                </ul>
              </div>
              <p v-else>No children’s trust created</p>
            </div>
          </div>

          <p v-else>No Children</p>
        </v-col>
      </v-row>
      <v-divider />
      <v-row class="mt-3">
        <v-col cols="12" lg="6">
          <h4>Executor(s):</h4>
          <div v-if="testator.executorParty">
            <p
              v-if="
                testator.executorParty == 'FRIEND_OR_FAMILY' &&
                relations.executor.fullName
              "
            >
              {{ relations.executor.fullName }} -
              {{ formatPersonKinship(relations.executor.kinship) }}
            </p>
            <p v-else-if="testator.executorParty == 'INTERNAL_COMPANY'">
              {{ whitelabel.internalExecutorName }}
            </p>
            <p v-else-if="testator.executorParty == 'ADVISOR_COMPANY'">
              {{ testator.company?.tradingName }}
            </p>

            <p v-if="relations.coExecutor.id">
              {{ relations.coExecutor.fullName }} -
              {{ formatPersonKinship(relations.coExecutor.kinship) }}
            </p>
          </div>
          <p v-else>No Executor selected</p>

          <h4>Alternative Executor:</h4>
          <p
            v-if="
              testator.alternativeExecutorParty == 'FRIEND_OR_FAMILY' &&
              relations.alternativeExecutor.fullName
            "
          >
            {{ relations.alternativeExecutor.fullName }} -
            {{ formatPersonKinship(relations.alternativeExecutor.kinship) }}
          </p>
          <p
            v-else-if="testator.alternativeExecutorParty == 'INTERNAL_COMPANY'"
          >
            {{ whitelabel.internalExecutorName }}
          </p>
          <p v-else-if="testator.alternativeExecutorParty == 'ADVISOR_COMPANY'">
            {{ testator.company?.tradingName }}
          </p>
          <p v-else>No alternative Executor selected</p>
        </v-col>
        <v-col v-if="testator.company" cols="12" lg="6">
          <ExecutorFees :testator="testator" />
        </v-col>
      </v-row>
      <v-divider />
    </v-card-text>
  </v-card>
</template>

<script>
  import { getAge, formatKinship } from '../../../constants/js/people';
  import ExecutorFees from './ExecutorFees.vue';

  export default {
    name: 'ChildrenCard',
    components: {
      ExecutorFees,
    },
    props: {
      testator: {
        required: true,
        type: Object,
      },
      relations: {
        required: true,
        type: Object,
      },
    },
    computed: {
      maritalRegime() {
        switch (this.testator.maritalRegime) {
          case 'IN_COMMUNITY':
            return 'Married in community of property';
          case 'OUT_OF_COMMUNITY_ACCRUAL':
            return 'Married out of community of property with accrual';
          case 'OUT_OF_COMMUNITY_NO_ACCRUAL':
            return 'Married out of community of property without accrual';
          case 'LIFE_PARTNER':
            return 'Married life partner';
          case 'MUSLIM_RITES':
            return 'Married in terms of Muslim rites';
          case 'CUSTOMARY':
            return 'Married in terms of Customary Laws';
          default:
            return 'Marital regime not yet specified';
        }
      },
      maritalStatus() {
        switch (this.testator.maritalStatus) {
          case 'MARRIED':
            return 'Married';
          case 'SINGLE':
            return 'Single';
          case 'LIVING_BUT_NOT_MARRIED':
            return 'Living with a partner but not married';
          case 'CIVIL_PARTNERSHIP':
            return 'Civil Partnership';
          case 'ENGAGED':
            return 'Engaged';
          case 'WIDOWED_AND_REMARRIED':
            return 'Widowed and remarried';
          case 'WIDOWED':
            return 'Widowed';
          case 'MARRIED_BUT_SEPARATED':
            return 'Married but separated';
          case 'CIVIL_PARTNERSHIP_BUT_SEPARATED':
            return 'Civil partnership but separated';
          case 'DIVORCED':
            return 'Divorced';
          case 'NOT_MARRIED':
            return 'Not married';
          default:
            return 'Not specified';
        }
      },
      isZAWill() {
        return this.testator.willCountry == 'ZA';
      },
      isGBWill() {
        return this.testator.willCountry == 'GB';
      },
      currencySymbol() {
        return this.isGBWill ? '£' : 'R';
      },
    },
    methods: {
      age(dob) {
        return getAge(dob);
      },
      formatPersonKinship(kinship) {
        return formatKinship(kinship, this.testator);
      },
    },
  };
</script>
